import { useEffect, useState } from 'react'
import { MdOutlineCardMembership } from "react-icons/md";
import { useLocation, useNavigate } from 'react-router-dom';
import { RxCross1 } from 'react-icons/rx';
import { BsSearch } from 'react-icons/bs';
import { RiArrowDownSFill } from 'react-icons/ri';
import Pagination from '../../components/Pagination';
import baseURL from '../../config/api';
import { formatUSPhone } from '../../utils/phoneFormatter';
import useGroup from '../../hook/useGroup';
import Cookies from 'js-cookie';
import SendSms from '../../components/SendSms';
import SendEmail from '../../components/SendEmail';
import { isPremiumPlan } from '../../utils/isPremiumPlan';

const orderBy = "desc";
const sortBy = "id";

const Leadership = () => {
  const token = Cookies.get("token-my-cdir");
  const plan = Cookies.get("plan-my-cdir") || "";
  const { selectedGroupId, isSuperAdmin }: any = useGroup();
  const pathRoot = isSuperAdmin ? "superadmin" : "admin";
  const navigate = useNavigate();
  const location = useLocation();
  const [showEntries, setShowEntries] = useState<number>(10);
  const [searchTableData, setSearchTableData] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [displayFilter, setDisplayFilter] = useState<boolean>(false);
  const [eventFilterValue, setEventFilterValue] = useState(0);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [paginationModel, setPaginationModel] = useState<{ page: number, size: number }>({
    page: 0,
    size: 10,
  });
  const [totalLength, setTotalLength] = useState<number>(0);
  const [selectedFilter, setSelectedFilter] = useState<string>("Name");
  const [isFirstTime, setIsFirstTime] = useState<boolean>(true);

  const [showTheSmsPopup, setShowTheSmsPopup] = useState<boolean>(false);
  const [showTheEmailPopup, setShowTheEmailPopup] = useState<boolean>(false);

  useEffect(() => {
    if (!isFirstTime) {
      setSelectedFilter("Name");
      setEventFilterValue(0);
      if (searchValue !== "") {
        setSearchValue("");
        setIsFirstTime(false);
      }
      else {
        setPaginationModel({
          page: 0,
          size: 10
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedGroupId])

  useEffect(() => {
    if (searchValue === "" && !isFirstTime) {
      const newPaginationModel = {
        page: 0,
        size: paginationModel.size,
      };

      setPaginationModel(newPaginationModel);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  useEffect(() => {
    if (searchValue === "") {
      setIsFirstTime(false)
      apiCall(paginationModel);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel])

  const apiCall = (newPaginationModel: { page: number, size: number }) => {
    if (selectedGroupId > 0) {
      setIsDataLoaded(true);
      fetch(`${baseURL}leaderships/GetLeadershipsPaging/${selectedGroupId},${sortBy},${orderBy},${newPaginationModel.page},${newPaginationModel.size}`,
        {
          headers: {
            Authorization: `Bearer ${token?.toString()}`
          }
        }
      )
        .then((res) => res.json())
        .then((data) => {
          const result = data.leaderships.map((item: any) => {
            return {
              ...item,
              imageUrl: item?.imageUrl ? `${baseURL}commonFile/Get?name=${item.imageUrl}` :
                "./images/user-default.jpg",
            };
          })

          setSearchTableData(result);
          setTotalLength(data.count);
          setIsDataLoaded(false);

        }).catch((error) => {
          console.log(error);
          setIsDataLoaded(false);
          setSearchTableData([]);
          setTotalLength(0);
        });
    }
    else {
      setIsDataLoaded(false);
      setSearchTableData([]);
      setTotalLength(0);
    }
  }

  useEffect(() => {
    if (location.state?.refresh) {
      apiCall(paginationModel);
      navigate(location.pathname, { replace: true, state: {} });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  useEffect(() => {
    let timeOutId: NodeJS.Timeout;

    if (searchValue !== "") {
      timeOutId = setTimeout(() => {
        const newPaginationModel = {
          page: 0,
          size: paginationModel.size,
        };

        setPaginationModel(newPaginationModel);

      }, 1000);
    }

    return () => clearTimeout(timeOutId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  useEffect(() => {
    if (searchValue !== "" && !isFirstTime) {
      filteApiCall(paginationModel);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel])

  const filteApiCall = (newPaginationModel: { page: number, size: number }) => {
    let filterData: any[] = [];
    setIsDataLoaded(true);
    switch (eventFilterValue) {
      case 0:
        fetch(
          `${baseURL}leaderships/GetLeadershipsByCustomerNumberPaging?customerName=${searchValue}&groupId=${selectedGroupId}&sortBy=${sortBy}&orderby=${orderBy}&page=${newPaginationModel.page}&size=${newPaginationModel.size}`,
          {
            headers: {
              Authorization: `Bearer ${token?.toString()}`
            }
          }
        )
          .then((res) => res.json())
          .then((data) => {
            filterData = data.leaderships.map((item: any) => {
              return {
                ...item,
                imageUrl: item?.imageUrl ? `${baseURL}commonFile/Get?name=${item.imageUrl}` :
                  "./images/user-default.jpg",
              };
            });
            setSearchTableData(filterData);
            setTotalLength(data.count);
            setIsDataLoaded(false);

          })
          .catch((error) => {
            console.log(error);
            setIsDataLoaded(false);
            setSearchTableData([]);
            setTotalLength(0);
          });
        break;

      case 1:
        fetch(
          `${baseURL}leaderships/GetLeadershipsByEmailPaging?email=${searchValue}&groupId=${selectedGroupId}&sortBy=${sortBy}&orderby=${orderBy}&page=${newPaginationModel.page}&size=${newPaginationModel.size}`,
          {
            headers: {
              Authorization: `Bearer ${token?.toString()}`
            }
          }
        )
          .then((res) => res.json())
          .then((data) => {
            filterData = data.leaderships.map((item: any) => {
              return {
                ...item,
                imageUrl: item?.imageUrl ? `${baseURL}commonFile/Get?name=${item.imageUrl}` :
                  "./images/user-default.jpg",
              };
            });
            setSearchTableData(filterData);
            setTotalLength(data.count);
            setIsDataLoaded(false);

          })
          .catch((error) => {
            console.log(error);
            setIsDataLoaded(false);
            setSearchTableData([]);
            setTotalLength(0);
          });
        break;

      case 2:
        fetch(
          `${baseURL}leaderships/GetLeadershipsByPhoneNumberPaging?phoneNumber=${searchValue}&groupId=${selectedGroupId}&sortBy=${sortBy}&orderby=${orderBy}&page=${newPaginationModel.page}&size=${newPaginationModel.size}`,
          {
            headers: {
              Authorization: `Bearer ${token?.toString()}`
            }
          }
        )
          .then((res) => res.json())
          .then((data) => {
            filterData = data.leaderships.map((item: any) => {
              return {
                ...item,
                imageUrl: item?.imageUrl ? `${baseURL}commonFile/Get?name=${item.imageUrl}` :
                  "./images/user-default.jpg",
              };
            });
            setSearchTableData(filterData);
            setTotalLength(data.count);
            setIsDataLoaded(false);

          })
          .catch((error) => {
            console.log(error);
            setIsDataLoaded(false);
            setSearchTableData([]);
            setTotalLength(0);
          });
        break;
      case 3:
        fetch(
          `${baseURL}leaderships/GetLeadershipsByGroupNamePaging?groupName=${searchValue}&groupId=${selectedGroupId}&sortBy=${sortBy}&orderby=${orderBy}&page=${newPaginationModel.page}&size=${newPaginationModel.size}`,
          {
            headers: {
              Authorization: `Bearer ${token?.toString()}`
            }
          }
        )
          .then((res) => res.json())
          .then((data) => {
            filterData = data.leaderships.map((item: any) => {
              return {
                ...item,
                imageUrl: item?.imageUrl ? `${baseURL}commonFile/Get?name=${item.imageUrl}` :
                  "./images/user-default.jpg",
              };
            });
            setSearchTableData(filterData);
            setTotalLength(data.count);
            setIsDataLoaded(false);

          })
          .catch((error) => {
            console.log(error);
            setIsDataLoaded(false);
            setSearchTableData([]);
            setTotalLength(0);
          });
        break;
    }
  }

  const applyFilter = () => {
    switch (eventFilterValue) {
      case 1:
        setSelectedFilter("Email Address");
        break;
      case 2:
        setSelectedFilter("Phone Number");
        break;
      case 3:
        setSelectedFilter("Group Name");
        break;
      case 0:
      default:
        setSelectedFilter("Name");
        break;
    }

    setSearchValue("");
    setDisplayFilter(false);
  };

  const clearFilter = () => {
    setSearchValue("");
    setDisplayFilter(false);
  };

  const addLeadership = () => {
    navigate(`/${pathRoot}/leadership/addLeadership`);
  }

  const editLeadership = (id: string) => {
    navigate(`/${pathRoot}/leadership/editLeadership/${id}`);
  }

  const deleteLeadership = (id: string) => {
    navigate(`/${pathRoot}/leadership/deleteLeadership/${id}`);
  }

  return (
    <>
      <section className="event__container p-3 md:p-4 overflow-x-hidden">
        <div className="min-w-full flex flex-col md:flex-row justify-between items-start md:items-center gap-3">
          <h1 className="px-2 md:px-4 py-1.5 flex items-center gap-2 text-base md:text-lg">
            <MdOutlineCardMembership fontSize={20} />
            <span className="text-base md:text-lg">Leadership</span>
          </h1>

          <div className="flex flex-col md:flex-row gap-2 md:gap-4 w-full md:w-auto">
            {
              (isSuperAdmin || isPremiumPlan(plan)) && (
                <>
                  <button
                    className="bg-secondary hover:bg-custom-blue px-4 py-2 md:py-1.5 rounded-sm text-white w-full md:w-auto"
                    onClick={() => setShowTheSmsPopup(true)}
                  >
                    SMS To All Leadership
                  </button>

                  <button
                    className="bg-secondary hover:bg-custom-blue px-4 py-2 md:py-1.5 rounded-sm text-white w-full md:w-auto"
                    onClick={() => setShowTheEmailPopup(true)}
                  >
                    Email To All Leadership
                  </button>
                </>
              )
            }

            <button
              className="bg-secondary hover:bg-custom-blue px-4 py-2 md:py-1.5 rounded-sm text-white w-full md:w-auto"
              onClick={addLeadership}
            >
              Add Leadership
            </button>
          </div>
        </div>

        {/* FILTER + SEARCH */}
        <div className="flex flex-col xm:flex-row gap-3 justify-between xm:items-center border border-black p-2 mt-4">
          <div className="relative flex flex-col xm:flex-row gap-3 items-start xm:items-center w-full">

            <div className='relative w-full xm:w-auto'>
              <button
                className="bg-secondary text-white px-3 py-2 xm:py-1 rounded-md flex items-center justify-between w-full xm:w-auto whitespace-nowrap"
                onClick={() => setDisplayFilter(!displayFilter)}
              >
                {selectedFilter}
                <RiArrowDownSFill className="ml-1" />
              </button>

              <div
                className={`${displayFilter ? "block" : "hidden"
                  } absolute z-10 w-full xm:w-40 p-2 bg-white border border-black mt-2 xm:mt-0 xm:top-0 xm:left-full`}
              >
                <div className="flex justify-between">
                  <label className="text-xs font-bold" htmlFor="fields">
                    Fields
                  </label>
                  <div
                    onClick={() => setDisplayFilter(false)}
                    className="w-4 h-4 cursor-pointer text-sm text-center"
                  >
                    <RxCross1 />
                  </div>
                </div>

                <select
                  className="w-full text-xs py-1 border mt-1"
                  name="fields"
                  value={eventFilterValue}
                  onChange={(e) =>
                    setEventFilterValue(parseInt(e.target.value))
                  }
                >
                  <option value="0">Name</option>
                  <option value="1">Email Address</option>
                  <option value="2">Phone Number</option>
                  <option value="3">Group Name</option>
                </select>

                <div className='flex mt-2 justify-between'>
                  <button
                    className="text-xs bg-secondary text-white py-1 px-2 rounded-md mt-3 w-full mr-1 whitespace-nowrap"
                    onClick={() => applyFilter()}
                  >
                    Apply Filter
                  </button>

                  <button
                    className="text-xs bg-secondary text-white py-1 px-2 rounded-md mt-3 w-full ml-1"
                    onClick={() => clearFilter()}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>

            {/* SEARCH */}
            <div className="flex items-center gap-2 w-full border px-2 py-1 rounded xm:border-none">
              <div className="h-4 w-4 text-gray-900">
                <BsSearch />
              </div>

              <input
                type="text"
                placeholder="Search…"
                className="w-full text-sm xm:text-lg pl-2 outline-none"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="my-2" />

        {!isDataLoaded ? (
          <>
            {searchTableData.length > 0 ? (
              <div className="member__list__container grid grid-cols-1 xm:grid-cols-2 gap-y-4 gap-x-2">
                {searchTableData?.slice(0, showEntries)?.map((item) => (
                  <div key={item?.id} className="flex items-start gap-4 flex-col xm:flex-row p-3 border rounded-lg shadow-sm">


                    <img
                      src={item?.imageUrl}
                      alt={`${item?.firstName} ${item?.lastName}`}
                      className="w-full xm:w-[150px] xm:h-[150px] object-cover object-top"
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "/images/user-default.jpg";
                      }}
                    />


                    <div className="w-full p-2 xm:ml-2">
                      <h4 className="text-sm xm:text-base font-bold break-words">
                        {item?.firstName?.trim()} {item?.lastName?.trim()}
                      </h4>

                      <p className="text-xs text-gray-600 mt-1">
                        {item?.designation?.trim()}
                      </p>

                      {item?.email && (
                        <p className="text-xs mt-1 break-all">{item?.email}</p>
                      )}

                      {item?.phoneNumber && (
                        <p className="text-xs mt-1">
                          {formatUSPhone(item?.phoneNumber)}
                        </p>
                      )}

                      <p className="text-xs mt-1">Order: {item?.order}</p>

                      {item?.leadershipGroups?.length > 0 && (
                        <div className="flex flex-wrap gap-2 mt-2">
                          {item.leadershipGroups.map((g: any) => (
                            <span
                              key={g.id || g.leadershipGroupId}
                              className="text-xs px-2 py-1 bg-blue-100 text-custom-blue rounded-full"
                            >
                              {g.leadershipGroupName?.trim()}
                            </span>
                          ))}
                        </div>
                      )}

                      {/* ACTION ICONS (UNCHANGED) */}
                      <div className="flex gap-4 mt-4">
                        <button
                          type="button"
                          className="w-7 h-7 flex items-center justify-center"
                          onClick={() => editLeadership(item.id)}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 fill-secondary hover:fill-custom-blue"
                            viewBox="0 0 348.882 348.882">
                            <path
                              d="m333.988 11.758-.42-.383A43.363 43.363 0 0 0 304.258 0a43.579 43.579 0 0 0-32.104 14.153L116.803 184.231a14.993 14.993 0 0 0-3.154 5.37l-18.267 54.762c-2.112 6.331-1.052 13.333 2.835 18.729 3.918 5.438 10.23 8.685 16.886 8.685h.001c2.879 0 5.693-.592 8.362-1.76l52.89-23.138a14.985 14.985 0 0 0 5.063-3.626L336.771 73.176c16.166-17.697 14.919-45.247-2.783-61.418zM130.381 234.247l10.719-32.134.904-.99 20.316 18.556-.904.99-31.035 13.578zm184.24-181.304L182.553 197.53l-20.316-18.556L294.305 34.386c2.583-2.828 6.118-4.386 9.954-4.386 3.365 0 6.588 1.252 9.082 3.53l.419.383c5.484 5.009 5.87 13.546.861 19.03z"
                              data-original="#000000" />
                            <path
                              d="M303.85 138.388c-8.284 0-15 6.716-15 15v127.347c0 21.034-17.113 38.147-38.147 38.147H68.904c-21.035 0-38.147-17.113-38.147-38.147V100.413c0-21.034 17.113-38.147 38.147-38.147h131.587c8.284 0 15-6.716 15-15s-6.716-15-15-15H68.904C31.327 32.266.757 62.837.757 100.413v180.321c0 37.576 30.571 68.147 68.147 68.147h181.798c37.576 0 68.147-30.571 68.147-68.147V153.388c.001-8.284-6.715-15-14.999-15z"
                              data-original="#000000" />
                          </svg>
                        </button>

                        <button
                          type="button"
                          className="w-7 h-7 flex items-center justify-center"
                          onClick={() => deleteLeadership(item.id)}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 fill-red-500 hover:fill-red-700" viewBox="0 0 24 24">
                            <path
                              d="M19 7a1 1 0 0 0-1 1v11.191A1.92 1.92 0 0 1 15.99 21H8.01A1.92 1.92 0 0 1 6 19.191V8a1 1 0 0 0-2 0v11.191A3.918 3.918 0 0 0 8.01 23h7.98A3.918 3.918 0 0 0 20 19.191V8a1 1 0 0 0-1-1Zm1-3h-4V2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2H4a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2ZM10 4V3h4v1Z"
                              data-original="#000000" />
                            <path d="M11 17v-7a1 1 0 0 0-2 0v7a1 1 0 0 0 2 0Zm4 0v-7a1 1 0 0 0-2 0v7a1 1 0 0 0 2 0Z"
                              data-original="#000000" />
                          </svg>

                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="min-w-full h-[120px] flex justify-center items-center">
                <span className="text-sm">No Data Found</span>
              </div>
            )}

            {totalLength > 0 && (
              <div className="mt-6 flex flex-col xm:flex-row items-center justify-between gap-3">
                <Pagination
                  pageOption={[5, 10, 15, 20, 25, 50, 75, 100]}
                  totalLength={totalLength}
                  paginationModel={paginationModel}
                  setPaginationModel={setPaginationModel}
                  showEntries={showEntries}
                  setShowEntries={setShowEntries}
                />
              </div>
            )}
          </>
        ) : (
          <div className="min-w-full h-[300px] xm:h-[480px] flex justify-center items-center">
            <div className="flex flex-col items-center">
              <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent text-secondary"></div>
              <span className="text-sm mt-2">Loading...</span>
            </div>
          </div>
        )}
      </section>

      {
        (isSuperAdmin || isPremiumPlan(plan)) && (
          <>
            <SendSms
              open={showTheSmsPopup}
              onClose={() => setShowTheSmsPopup(false)}
              entityType="Leadership"
              entityId={0}
              entityName={`All Leadership`}
            />

            <SendEmail
              open={showTheEmailPopup}
              onClose={() => setShowTheEmailPopup(false)}
              entityType="Leadership"
              entityId={0}
              entityName={`All Leadership`}
            />
          </>
        )
      }
    </>
  )
}

export default Leadership;